import { FormControl, FormControlLabel, Switch, Tooltip } from '@mui/material'
import React from 'react'

import AiUsageHelper from './ai-usage-helper'

type Props = {
  disabled?: boolean
  transcribe: boolean
  onChange: (value: boolean) => void
}

const TranscribeToggle: React.FC<Props> = ({ disabled, transcribe, onChange }) => {
  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.checked),
    [onChange],
  )

  return (
    <FormControl>
      <Tooltip title="Transcribe answer with AI">
        <div>
          <FormControlLabel
            className="transcribe-toggle"
            control={<Switch checked={!!transcribe} onChange={handleChange} />}
            disabled={disabled}
            label="Transcribe answer"
          />
        </div>
      </Tooltip>
      <AiUsageHelper text="We use AI to translate the audio to text." />
    </FormControl>
  )
}

export default TranscribeToggle
